<template>
  <div class="container">
    <nav>
      <div>
        <p>Hey! {{ user.displayName}} show your mood here!</p>
      </div>
    </nav>
    <div class="window">
      <div class="messages" v-if="formatteddoc" ref="chatwindow">
        <div class="single" v-for="doc in formatteddoc" :key="doc.id">
          <span class="created-at">{{ doc.createdAt }}</span>
          <span class="name">{{ doc.name }}</span>
          <span class="message">{{ doc.message }}</span>
        </div>
      </div>
    </div>
    <form @submit.prevent="handleSubmit" class="chat-input">
      <textarea placeholder="Type a message and hit enter to send..." v-model="message" @keypress.enter.prevent="handleSubmit"></textarea>
      <button type="submit" class="send">Send</button>
    </form>
  </div>
</template>

<script>
import getUser from '../composables/getUser'
import useCollection from '../composables/useCollection'
import getCollection from '../composables/getCollection'
import { formatDistanceToNow } from 'date-fns'
import { computed, onUpdated, ref } from 'vue'
import { timestamp } from '../firebase/config'

export default {
  setup() {
    const { user } = getUser();
    const message = ref('');
    const { documents } = getCollection('messages');
    const formatteddoc = computed(() => {
      if(documents.value) {
        return documents.value.map((item) => {
          let time = formatDistanceToNow(item.createdAt.toDate());
          return { ...item, createdAt: time };
        });
      }
    });
    const { addDoc, error } = useCollection('messages');
    const handleSubmit = async () => {
      const chat = {
        name: user.value.displayName,
        message: message.value,
        createdAt: timestamp()
      }
      await addDoc(chat);
      console.log('pass');
      if(!error.value){
        message.value = '';
      }
    }
    const chatwindow = ref(null);
    onUpdated(() => {
      chatwindow.value.scrollTop = chatwindow.value.scrollHeight;
    })
    return { user, error, documents, addDoc, formatteddoc, handleSubmit, message, chatwindow }
  }
}
</script>

<style scoped>
  .container {
    width: 100%;
    max-width: 800px;
    margin: 80px auto;
    border-radius: 20px;
    box-shadow: 2px 4px 6px rgba(28, 6, 49, 0.1);
    background: white;
  }
  nav {
    padding: 20px;
  }
  nav p {
    margin: 2px auto;
    font-size: 16px;
    color: rgb(102, 101, 101);
  }
  .window {
    background: #fafafa;
    padding: 15px 20px;
  }
  .messages {
    max-height: 250px;
    overflow: auto;
  }
  .single {
    margin: 18px 0;
  }
  .created-at {
    display: block;
    color: #999;
    font-size: 12px;
    margin-bottom: 4px;
  }
  .name {
    font-weight: bold;
    margin-right: 10px;
  }
  .chat-input {
    border: none;
    box-shadow: none;
    max-width:500px;
    padding: 10px;
    border-radius: 0;
    display: flex;
    align-items: center;
  }
  .chat-input button {
    margin-left: 20px;
  }
  .chat-input textarea {
    padding: 5px;
  }
</style>